import { Controller } from "@hotwired/stimulus"

const TRIGGER = "[data-ipksef-payment-warn]"
const BULK_TRIGGER = "[data-ipksef-payment-warn-bulk]"

// Ostrzeżenie przed edycją/usunięciem płatności IPKSeF: „Dalej" ponawia klik wyzwalacza z flagą, a akcję (data-method/remote/inline onclick) wykonuje UJS.
export default class extends Controller {
  // Zaznaczenie czytamy z list--bulk; na stronie płatności outletu nie ma, bo nie ma tam masowego usuwania.
  static outlets = ["list--bulk"]

  link = null

  connect() {
    this.onClick = this.intercept.bind(this)
    this.onModalValue = this.forget.bind(this)
    // Wyzwalacze są poza kontrolerem, UJS słucha na document, a masowe usuwanie ma inline onclick — wyprzedza je tylko faza przechwytywania.
    document.addEventListener("click", this.onClick, true)
    // modal#hide (tło/Escape/Anuluj) ogłasza modal:value — bez wyzerowania linku „Dalej" wykonałby odrzuconą akcję.
    this.element.addEventListener("modal:value", this.onModalValue)
  }

  disconnect() {
    document.removeEventListener("click", this.onClick, true)
    this.element.removeEventListener("modal:value", this.onModalValue)
  }

  intercept(event) {
    const trigger = event.target.closest?.(`${TRIGGER}, ${BULK_TRIGGER}`)
    if (!trigger || trigger.dataset.ipksefWarned) return
    // Bez zaznaczonej płatności IPKSeF masowe usuwanie zostaje przy natywnym confirm wyzwalacza.
    if (trigger.matches(BULK_TRIGGER) && !this.ipksefChecked) return

    event.preventDefault()
    event.stopPropagation()
    this.link = trigger
    this.element.dispatchEvent(new CustomEvent("modal:open"))
  }

  // recordTargets, nie selectedRecords: to drugie zapełnia się dopiero przy change, więc po „wstecz" bywa puste mimo zaznaczeń.
  get ipksefChecked() {
    return this.hasListBulkOutlet &&
      this.listBulkOutlet.recordTargets.some(checkbox => checkbox.checked && checkbox.dataset.ipksef)
  }

  forget() {
    this.link = null
  }

  proceed() {
    if (!this.link) return

    const link = this.link
    link.dataset.ipksefWarned = "1"
    this.element.dispatchEvent(new CustomEvent("modal:close"))
    try {
      link.click()
    } finally {
      // klik jest synchroniczny; flaga nie może zostać, bo po nieudanym usunięciu kolejny klik poszedłby bez ostrzeżenia
      delete link.dataset.ipksefWarned
    }
  }
}
